<template>
  <div
    :class="{'stack-vertically' : stackVertically}"
    class="prev-next-arrows"
  >
    <remote-control-button
      :is-disabled="disablePrevTooltip"
      :tooltip-text="prevItemTooltipText"
      :tooltip-placement="tooltipPlacement"
      icon-name="caret-up"
      @click="$emit('navigate', previousItem)"
    />
    <remote-control-button
      :is-disabled="disableNextTooltip"
      :tooltip-text="nextItemTooltipText"
      :tooltip-placement="tooltipPlacement"
      icon-name="caret-down"
      @click="$emit('navigate', nextItem)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { IBreadcrumbItemMenuItem } from '@/types/data-objects/items'

export default defineComponent({
  name: 'PrevNextArrows',

  props: {
    previousItem: {
      type: Object as () => IBreadcrumbItemMenuItem,
      default: null,
    },
    nextItem: {
      type: Object as () => IBreadcrumbItemMenuItem,
      default: null,
    },
    stackVertically: {
      type: Boolean,
      default: false,
    },
    tooltipPlacement: {
      type: String,
      default: 'bottom',
    },
  },

  emits: ['navigate'],

  computed: {
    disablePrevTooltip(): boolean {
      return (
        this.previousItem === null || this.previousItem.refNumber === undefined
      )
    },
    disableNextTooltip(): boolean {
      return this.nextItem === null || this.nextItem.refNumber === undefined
    },
    prevItemTooltipText(): string {
      if (this.disablePrevTooltip) {
        return ''
      }
      return `#${this.previousItem.refNumber}: ${this.previousItem.title}`
    },
    nextItemTooltipText(): string {
      if (this.disableNextTooltip) {
        return ''
      }
      return `#${this.nextItem.refNumber}: ${this.nextItem.title}`
    },
  },
})
</script>

<style lang="scss">
.prev-next-arrows {
  display: flex;
  @include flex-row-horizontal-spacing(10px);

  &.stack-vertically {
    flex-direction: column;
    > *:not(:last-child) {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
}
</style>
